import React from 'react';
import Flexbox from 'flexbox-react';
import PropTypes from 'prop-types';
import ProcessField from 'components/core/fields/ProcessField';
import RIEComboBox from 'components/core/editable/RIEComboBox';
import InfoBoxLabel from 'components/core/InfoBoxLabel';
import Constants from 'utils/Constants';

export default class InputDatastreamsField extends ProcessField {
    static propTypes = Object.assign({
        dods: PropTypes.array
    }, ProcessField.propTypes);

    static defaultProps = Object.assign({
    }, ProcessField.defaultProps);

    onDatastreamsUpdated = (fieldPath, fieldValue) => {
        // These are combo boxes, so the values will be an array of objects
        // We must map to an array of strings
        const value = fieldValue.map((option) => {
            return option.value;
        });
        this.onFieldUpdated(fieldPath, value);
    };

    render() {
        const process = this.props.process;
        const inputDatastreams = process.input_datastreams.map((v) => {
            return { value: v, label: v };
        });

        const dodOptions = Constants.convertArrayToSelectOptions(this.props.dods);

        return (
            <Flexbox flexDirection="row" alignItems="flex-start" className={this.props.className}>
                <InfoBoxLabel className="nowrap" label="Input Datastreams" alignTop/>
                <Flexbox flexDirection="column" width="100%">
                    <RIEComboBox
                        value={inputDatastreams}
                        change={this.onDatastreamsUpdated}
                        fieldPath={['input_datastreams']}
                        options={dodOptions}
                        multi
                        clearable
                        creatable
                        isDisabled={!this.props.hasWritePermissions}
                        processId={this.props.process.name}
                        processErrors={this.props.processErrors}
                        formDisplay={this.props.forceFormDisplay}
                    />

                    {/* Only show the legend if using variable_retrieval */}
                    {process.variable_retrieval && process.input_datastreams.length > 0 ?
                        <Flexbox direction="row" alignItems="center" margin="0 0 5px 5px" width="100%">
                            <span className="footnote">
                                <i className="fa fa-square orange" aria-hidden="true" />&nbsp;
                                Used in variable retrieval
                            </span>
                        </Flexbox>
                        : ''}
                </Flexbox>
            </Flexbox>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/core/fields/InputDatastreamsField.js